export function getCountryCode(locale: string): string {
    return locale.split('_')[1] || locale.split('-')[1];
}
